import {Box, Paper} from '@mui/material';
import React, {useCallback, useRef} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import ContactForm from '../../forms/ContactForm';
import ContactLocations from './ContactLocations';
import NewOrExistingContact from './NewOrExistingContact';
import Who from './Who';

const NewContact = ({onBack, onNext, session}) => {
  /** @type {({current: ContactForm})} */
  const formRef = useRef();

  const handleBack = useCallback(() => {
    onBack(
      session.selectedCompany ?
        {type: NewOrExistingContact.type, id: NewOrExistingContact.type} : {type: Who.type, id: Who.type}
    )
  }, [onBack, session]);

  return (
    <>
      <Header>Create a New Contact</Header>
      <Paper component={Box} padding={2}>
        <ContactForm ref={formRef} contact={{}} company={session?.selectedCompany ?? null} onSaved={(saved) => onNext(
          {type: ContactLocations.type, id: ContactLocations.type},
          {
            selectedContact: {
              id: saved.id,
              title: saved.title,
              first_name: saved.first_name,
              last_name: saved.last_name
            }
          }
        )}/>
      </Paper>
      <Controls
        onBack={handleBack}
        onNext={() => formRef.current.save()}
        nextLabel="Save New Contact"
      />
    </>
  );
};

NewContact.type = 'NEW_CONTACT';

export default NewContact;
